import React from 'react';
import { styled } from 'dripsy';

import { BaseText, IBaseTextProps } from '../common/BaseText';

const StyledText = styled(BaseText)({
  color: '$error400',
  variant: 'text.small',
  marginTop: '$2',
  marginLeft: '$8',
});

export interface IErrorTextProps extends IBaseTextProps {}

export function ErrorText(props: IErrorTextProps) {
  return <StyledText {...props}>{props.children}</StyledText>;
}
